import router from './router'

export default {}

// Auth object
let auth = {
  user: null,
  logout () {
    window.localStorage.removeItem('id_token')
    this.user = null
  },
  isLoggedIn () {
    if (window.localStorage.getItem('id_token') === null) {
      return false
    }
    return true
  },
  // Read the user from token on app start
  setUser () {
    const token = localStorage.getItem('id_token')
    if (token) {
      this.readToken(token)
    }
  },
  setToken (token) {
    localStorage.setItem('id_token', token)
    this.readToken(token)
  },
  getToken () {
    return localStorage.getItem('id_token')
  },
  readToken (token) {
    try {
      const payloadEncoded = token.split('.')[1]
      const payload = JSON.parse(window.atob(payloadEncoded))
      this.user = {
        id: payload.userId,
        name: payload.name,
        email: payload.email,
        saldo: payload.saldo,
        isSystem: payload.isSystem === 'True'
      }
    } catch (_) {}
  }
}

/* Apply route guards
 * router-docs: https://router.vuejs.org/en/advanced/meta.html
 */
const useAuth = () => {
  // Before each route, check if authentication is required
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.hasOwnProperty('requiresAuth') && !record.meta.requiresAuth) && auth.isLoggedIn()) {
      next('/dashboard/')
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!auth.isLoggedIn()) {
        next({
          path: '/signin',
          query: { redirect: to.fullPath }
        })
      } else {
        requiresSystem(to, from, next)
      }
    } else {
      next()
    }
  })

  const requiresSystem = (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresSystem)) {
      if (!auth.user.isSystem) {
        next({
          path: from.path
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
}

export {
  useAuth,
  auth
}



// WEBPACK FOOTER //
// ./src/auth.js